import { Link } from 'react-router-dom'
import { navigation } from '../data/content'
import { BOOSTPAD_DESCRIPTION } from '../lib/entity'

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="footer-lead">
        <Link className="wordmark" to="/">BOOSTPAD</Link>
        <p>{BOOSTPAD_DESCRIPTION}</p>
      </div>
      <nav aria-label="Footer navigation">{navigation.map(item => <Link key={item.href} to={item.href}>{item.label}</Link>)}</nav>
      <div className="footer-meta">
        <span>© {new Date().getFullYear()} Boostpad</span>
        <span>Buenos Aires · California · Worldwide</span>
      </div>
    </footer>
  )
}
